export default {
  'loading': 'Loading . . .',
  'nombre': 'Name',
  'telefono': 'Phone Number',
  'codigo': 'Code',
  'email': 'Email',
  'activo': 'Active',
  'estado': 'State',
  'descripcion': 'Description',
  'usuario': 'User',
  'clave': 'Password',
  'si': 'Yes',
  'no': 'No',
  'cargando': 'Loading...',
  'maestros': {
    'editar': 'Edit',
    'eliminar': 'Remove',
  },
  'mensajes': {
    'confirmar': 'Confirm',
    'pregunta-borrar': 'Are you sure you want to delete "',
  },
};
